import { CodeSwitcher } from '@/docs-partials/resources';
import * as React from 'react';
export default {
  CodeSwitcher,
  React
};